module.exports = __webpack_public_path__ + "img/icon_add.df32452b.770ad09f.svg";